import React from 'react';
import Image from 'atoms/Image';
import { ButtonComp } from 'atoms/Buttons';
import { CART_PAGE_CONSTANTS } from 'organisms/CartPage/Constants/CartPageConstants';
import EmptyCartImage from 'styles/staticAssets/images/empty_cart.png';
import { useHistory } from 'react-router-dom';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { localisationStartAnalytics } from 'common/utilities/analyticsUtils';
import { useSelector } from 'react-redux';
const { EMPTY_CART } = CART_PAGE_CONSTANTS;

function EmptyCartPlaceholder() {
  const userParams = useSelector(data => data.appStateReducer.userStatus);
  const history = useHistory();
  const onStartOrderClick = () => {
    !userParams?.localized && localisationStartAnalytics();
    history?.push({
      pathname: '/menu',
    });
  };

  return (
    <div className='cart-empty-placeholder cart-empty-root'>
      <div className='cart-empty-placeholder-view'>
        <span className='cart-empty-placeholder-text'>{translateWithI18Next(EMPTY_CART.PLACEHOLDER_TEXT)}</span>
        <ButtonComp
          className='button redButton start-order-btn cart-empty-placeholder-button'
          aria-label={translateWithI18Next(EMPTY_CART.START_ORDER)}
          onClickHandler={onStartOrderClick}
          id='startOrderItemButton'
          type='submit'
          data-testid='empty-cart-start-order-button'
        >
          <span>{translateWithI18Next(EMPTY_CART.START_ORDER)}</span>
        </ButtonComp>
      </div>
      <Image className='cart-empty-img' srcFile={EmptyCartImage} altText='' />
    </div>
  );
}

export default EmptyCartPlaceholder;
